import React from 'react'
import { Link, useLocation, useNavigate } from 'react-router'
import { useAuth } from '../contexts/AuthContext'
import XosaWordmark from './brand/XosaWordmark'
import HeaderSearch from './header/HeaderSearch'
import HeaderUserMenu from './header/HeaderUserMenu'
import NotificationBell from './notifications/NotificationBell'
import { Container } from './ui'

/**
 * App bar — wordmark, an always-visible search field, then Watchlist,
 * notifications and account on the right (DESIGN.md → Navigation).
 */
const Header: React.FC = () => {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const { user, logout } = useAuth()

  async function handleLogout() {
    await logout()
    navigate('/login', { replace: true })
  }

  const homeTo = user ? '/' : '/login'
  const onWatchlist = pathname.startsWith('/watchlist') || pathname.startsWith('/account/watchlist')

  return (
    <header className="relative bg-paper border-b border-rule print:hidden">
      <Container>
        <div className="flex items-center gap-3 sm:gap-6 h-[60px]">
          <Link
            to={homeTo}
            className="shrink-0 rounded-md hover:opacity-80 transition-opacity"
            aria-label="Xosa Origin, forside"
          >
            <XosaWordmark />
          </Link>

          {user && (
            <>
              <HeaderSearch />
              <nav
                aria-label="Hovednavigation"
                className="sm:ml-auto flex items-center gap-1.5"
              >
                <Link
                  to="/watchlist"
                  aria-current={onWatchlist ? 'page' : undefined}
                  className={`hidden md:inline-flex h-[38px] items-center rounded-md px-3.5 text-sm font-semibold text-ink transition-colors hover:bg-rule-soft ${
                    onWatchlist ? 'bg-rule-soft' : ''
                  }`}
                >
                  Watchlist
                </Link>
                <NotificationBell />
                <HeaderUserMenu name={user.name} onLogout={handleLogout} />
              </nav>
            </>
          )}
        </div>
      </Container>
    </header>
  )
}

export default Header
